import type { ServicesContent } from '@mawkaa/types';
import { cn } from '@mawkaa/ui';

interface ServicesBlockProps {
  content: ServicesContent;
  isEditing?: boolean;
}

export function ServicesBlock({ content, isEditing }: ServicesBlockProps) {
  const { title, subtitle, services = [], columns = 3, style = 'cards' } = content;

  const gridClasses = {
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-3',
    4: 'md:grid-cols-2 lg:grid-cols-4',
  };

  return (
    <section className="px-4 py-16">
      <div className="max-w-6xl mx-auto">
        {(title || subtitle) && (
          <div className="text-center mb-12">
            {title && <h2 className="text-3xl font-bold mb-4">{title}</h2>}
            {subtitle && <p className="text-lg text-muted-foreground">{subtitle}</p>}
          </div>
        )}

        <div className={cn('grid gap-8', gridClasses[columns])}>
          {services.length > 0 ? (
            services.map((service, index) => (
              <div
                key={index}
                className={cn(
                  style === 'cards' && 'bg-white rounded-lg shadow-sm border overflow-hidden',
                  style === 'list' && 'flex gap-4'
                )}
              >
                {service.image && (
                  <div className={cn(
                    style === 'cards' && 'aspect-[4/3]',
                    style === 'list' && 'w-24 h-24 shrink-0'
                  )}>
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <div className={cn(style === 'cards' && 'p-6')}>
                  <h3 className="font-semibold mb-2">{service.title}</h3>
                  <p className="text-sm text-muted-foreground mb-4">{service.description}</p>
                  {service.price && (
                    <p className="text-primary font-medium">{service.price}</p>
                  )}
                </div>
              </div>
            ))
          ) : isEditing ? (
            <div className="col-span-full text-center py-8 text-muted-foreground">
              Ajoutez des services dans le panneau de propriétés
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
